<template>
  <div class="wrapper">
    <div class="breadcrumb">{{$t("main.nav[1].title")}}</div>
    <div class="container" @mouseenter="on_enter" @mouseleave="on_leave">
      <swiper :options="swiperOption" class="gallery-main" v-if="imgList.length" ref="mySwiper">
        <swiper-slide v-for="item in imgList" :key="item">
          <img :src="item"/>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev swiper-btn" slot="button-prev"></div>
        <div class="swiper-button-next swiper-btn" slot="button-next"></div>
      </swiper>
      <div class="des">
        <div class="title">{{$t("main.des[1].list[0].title")}}</div>
        <div v-html='$t("main.des[1].list[0].text")'></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'doubleSwiper',
  data () {
    return {
      text: '$t("main.des[0].list[0].text")',
      imgList: [
        'static/images/main/hotel/hotel-01.jpg',
        'static/images/main/hotel/hotel-02.jpg',
        'static/images/main/hotel/hotel-03.jpg',
        'static/images/main/hotel/hotel-04.jpg',
        'static/images/main/hotel/hotel-05.jpg',
        'static/images/main/hotel/hotel-06.jpg',
        'static/images/main/hotel/hotel-07.jpg',
        'static/images/main/hotel/hotel-08.jpg',
        'static/images/main/hotel/hotel-09.jpg',
        'static/images/main/hotel/hotel-10.jpg',
        'static/images/main/hotel/hotel-11.jpg',
        'static/images/main/hotel/hotel-12.jpg',
        'static/images/main/hotel/hotel-13.jpg'
      ],
      // notNextTick: true,
      swiperOption: {
        autoHeight: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        },
        loop: true,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  mounted () {
  },
  beforeMount () {
  },
  computed: {
    mySwiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    on_enter () {
      this.mySwiper.autoplay.stop()
    },
    on_leave () {
      this.mySwiper.autoplay.start()
    }
  },
  created () {
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .wrapper
    width 78%
    font-size 15px
    line-height 26px
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
      b
        font-weight normal
        margin-left 10px
    .gallery-main:hover
      .swiper-btn,.swiper-pagination
        opacity 1
    .gallery-main
      .swiper-pagination
        opacity 0
        transition opacity 1s
      .swiper-btn
        background rgba(0,0,0,0.3)
        background-repeat no-repeat
        background-size cover
        border-radius 3px
        padding 4px 4px
        opacity 0
        transition opacity 1s
      .swiper-button-prev
        background-image url("~assets/common/width-64-left.png")
        background-position center left
      .swiper-button-next
        background-image url("~assets/common/width-64-right.png")
        background-position center right
    .des
      margin-top 50px
      padding 0 20px
      .title
        font-size 20px
        font-weight bold
        line-height 32px
      .des
        b
          font-weight bold
</style>



// WEBPACK FOOTER //
// src/pages/main/components/Hotel.vue